function focusability(container) {
  const hidden = container.getAttribute('aria-hidden') === 'true';
  const focusable = [...container.querySelectorAll('a, button, input, select, textarea, [tabindex]')];
  focusable.forEach(el => {
    el.setAttribute('tabindex', hidden ? -1 : 0);
    el.setAttribute('aria-hidden', hidden);
  });
}
DomObserver.observe('[aria-hidden]', containers => {
  containers.forEach(container => {
    const HiddenObserver = new MutationObserver(mutations => {
      mutations.forEach(() => focusability(container));
    });
    HiddenObserver.observe(container, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
    focusability(container);
  });
});